// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.order-action-container {
  padding: 1.5rem;
  background-color: var(--cui-body-bg);
  min-height: 100vh;
}
.order-action-container .order-action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--cui-border-color);
}
.order-action-container .order-action-header .header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.order-action-container .order-action-header .header-left .back-button {
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}
.order-action-container .order-action-header .header-left .back-button:hover {
  transform: translateX(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
.order-action-container .order-action-header .header-left .header-title h3 {
  margin: 0;
  font-weight: 600;
  color: var(--cui-body-color);
  font-size: 1.5rem;
}
.order-action-container .order-action-header .header-left .header-title .header-subtitle {
  color: var(--cui-secondary-color);
  font-size: 0.875rem;
  font-weight: 500;
}
.order-action-container .order-info-card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.order-action-container .order-info-card .card-body {
  padding: 1.5rem;
}
.order-action-container .order-info-card .info-item .info-label {
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
  margin-bottom: 0.25rem;
}
.order-action-container .order-info-card .info-item .info-value {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.order-action-container .action-form-card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}
.order-action-container .action-form-card .form-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 1px solid var(--cui-border-color);
  padding: 1.25rem 1.5rem;
}
.order-action-container .action-form-card .form-header h5 {
  margin: 0;
  font-weight: 600;
  color: var(--cui-body-color);
}
.order-action-container .action-form-card .card-body {
  padding: 2rem;
}
.order-action-container .wizard-progress .progress-bar {
  height: 8px;
  border-radius: 4px;
  background-color: #e9ecef;
}
.order-action-container .wizard-progress .progress-bar .progress-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}
.order-action-container .wizard-progress .progress-text {
  text-align: center;
  margin-top: 0.5rem;
  font-weight: 500;
  color: var(--cui-secondary-color);
  font-size: 0.875rem;
}
.order-action-container .action-selection .selection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}
.order-action-container .action-selection .selection-grid .selection-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 0.75rem;
  padding: 2rem 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.order-action-container .action-selection .selection-grid .selection-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}
.order-action-container .action-selection .selection-grid .selection-card.selected {
  border-color: #667eea;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}
.order-action-container .action-selection .selection-grid .selection-card.selected::before {
  content: "✓";
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 24px;
  height: 24px;
  background: #667eea;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.875rem;
}
.order-action-container .action-selection .selection-grid .selection-card .card-icon {
  margin-bottom: 1rem;
  color: #667eea;
}
.order-action-container .action-selection .selection-grid .selection-card h5 {
  margin: 0 0 0.5rem 0;
  font-weight: 600;
  color: var(--cui-body-color);
}
.order-action-container .action-selection .selection-grid .selection-card p {
  margin: 0;
  color: var(--cui-secondary-color);
  font-size: 0.875rem;
}
.order-action-container .form-step {
  padding: 1rem 0;
}
.order-action-container .review-step .review-summary h5 {
  margin-bottom: 1.5rem;
  color: var(--cui-body-color);
  font-weight: 600;
}
.order-action-container .review-step .review-summary .review-item {
  background: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-left: 4px solid #667eea;
}
.order-action-container .review-step .review-summary .review-item h6 {
  margin: 0 0 1rem 0;
  color: #667eea;
  font-weight: 600;
  font-size: 1rem;
}
.order-action-container .review-step .review-summary .review-item p {
  margin: 0.25rem 0;
  color: var(--cui-body-color);
  font-size: 0.875rem;
}
.order-action-container .review-step .review-summary .review-item p strong {
  color: var(--cui-body-color);
  font-weight: 600;
}
.order-action-container .wizard-form-card .form-header .step-description {
  margin: 0.5rem 0 0 0;
  color: var(--cui-secondary-color);
  font-size: 0.875rem;
}
.order-action-container .wizard-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--cui-border-color);
}
.order-action-container .wizard-navigation .nav-right {
  display: flex;
  gap: 1rem;
}
.order-action-container .wizard-navigation .nav-button {
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-action-container .wizard-navigation .submit-button {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-action-container .wizard-navigation .submit-button:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
}
.order-action-container .wizard-navigation .submit-button:disabled {
  background: #adb5bd;
  transform: none;
  box-shadow: none;
}
.order-action-container .wizard-navigation .cancel-button {
  border: 2px solid #6c757d;
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-action-container .wizard-navigation .cancel-button:hover {
  background-color: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);
}
.order-action-container .form-group {
  margin-bottom: 1.5rem;
}
.order-action-container .form-group .form-label {
  font-weight: 600;
  color: var(--cui-body-color);
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.order-action-container .form-group .form-label .text-danger {
  color: #dc3545 !important;
}
.order-action-container .form-group .form-control,
.order-action-container .form-group .form-select {
  border: 2px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  background-color: var(--cui-body-bg);
  color: var(--cui-body-color);
}
.order-action-container .form-group .form-control:focus,
.order-action-container .form-group .form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.order-action-container .form-group .form-control.is-invalid,
.order-action-container .form-group .form-select.is-invalid {
  border-color: #dc3545;
}
.order-action-container .form-group .form-control.is-invalid:focus,
.order-action-container .form-group .form-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.order-action-container .form-group .form-control::placeholder,
.order-action-container .form-group .form-select::placeholder {
  color: #adb5bd;
  font-style: italic;
}
.order-action-container .form-group .invalid-feedback {
  display: block !important;
  font-size: 0.75rem;
  color: #dc3545;
  margin-top: 0.25rem;
  font-weight: 500;
}
.order-action-container .form-group .invalid-feedback::before {
  content: "⚠ ";
  margin-right: 0.25rem;
}
.order-action-container .form-group .price-input-group .form-control {
  border: none;
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.order-action-container .form-group .price-input-group .form-control:focus {
  border: none;
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.order-action-container .form-group .price-input-group .price-whole,
.order-action-container .form-group .price-input-group .price-decimal {
  border: none;
  background: transparent;
  padding: 0;
}
.order-action-container .form-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--cui-border-color);
}
.order-action-container .form-actions .submit-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-action-container .form-actions .submit-button:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
}
.order-action-container .form-actions .submit-button:disabled {
  background: #adb5bd;
  transform: none;
  box-shadow: none;
}
.order-action-container .form-actions .cancel-button {
  border: 2px solid #6c757d;
  border-radius: 0.5rem;
  padding: 0.75rem 2rem;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.order-action-container .form-actions .cancel-button:hover {
  background-color: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);
}
.order-action-container .alert {
  border-radius: 0.5rem;
  border: none;
  padding: 1rem 1.5rem;
  margin-bottom: 1.5rem;
}
.order-action-container .alert.alert-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-left: 4px solid #28a745;
}
.order-action-container .alert.alert-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-left: 4px solid #dc3545;
}
.order-action-container .alert.alert-warning {
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border-left: 4px solid #ffc107;
}
.order-action-container .order-action-not-found {
  text-align: center;
  padding: 3rem 1rem;
}
.order-action-container .order-action-not-found .warning-alert {
  max-width: 500px;
  margin: 0 auto;
}

html[data-coreui-theme=dark] .order-action-container .order-info-card {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}
html[data-coreui-theme=dark] .order-action-container .action-form-card .form-header {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}
html[data-coreui-theme=dark] .order-action-container .custom-tabs .nav-item .custom-tab-link.active {
  background-color: var(--cui-dark-bg-subtle);
}
html[data-coreui-theme=dark] .order-action-container .form-control,
html[data-coreui-theme=dark] .order-action-container .form-select {
  background-color: var(--cui-dark-bg-subtle);
  border-color: var(--cui-dark-border-subtle);
  color: var(--cui-body-color);
}
html[data-coreui-theme=dark] .order-action-container .form-control:focus,
html[data-coreui-theme=dark] .order-action-container .form-select:focus {
  background-color: var(--cui-dark-bg-subtle);
}

@media (max-width: 768px) {
  .order-action-container {
    padding: 1rem;
  }
  .order-action-container .order-action-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  .order-action-container .order-action-header .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .order-action-container .form-actions {
    flex-direction: column;
  }
  .order-action-container .form-actions .submit-button,
  .order-action-container .form-actions .cancel-button {
    width: 100%;
  }
  .order-action-container .custom-tabs .nav-item .custom-tab-link {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
}
@media (max-width: 576px) {
  .order-action-container .action-form-card .card-body {
    padding: 1rem;
  }
  .order-action-container .form-group {
    margin-bottom: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/OrderAction/OrderAction.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,oCAAA;EACA,iBAAA;AAEF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;AAEJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEN;AAAM;EACE,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;AAER;AAAQ;EACE,2BAAA;EACA,0CAAA;AAEV;AAGQ;EACE,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AADV;AAIQ;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;AAFV;AAQE;EACE,YAAA;EACA,sBAAA;EACA,wCAAA;EACA,6DAAA;EACA,YAAA;AANJ;AAQI;EACE,eAAA;AANN;AAUM;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;AARR;AAWM;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AATR;AAcE;EACE,YAAA;EACA,sBAAA;EACA,0CAAA;EACA,gBAAA;AAZJ;AAcI;EACE,6DAAA;EACA,gDAAA;EACA,uBAAA;AAZN;AAcM;EACE,SAAA;EACA,gBAAA;EACA,4BAAA;AAZR;AAgBI;EACE,aAAA;AAdN;AAmBI;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;AAjBN;AAmBM;EACE,6DAAA;EACA,kBAAA;AAjBR;AAqBI;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AAnBN;AAwBI;EACE,aAAA;EACA,2DAAA;EACA,WAAA;EACA,gBAAA;AAtBN;AAwBM;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAtBR;AAwBQ;EACE,2BAAA;EACA,yCAAA;EACA,qBAAA;AAtBV;AAyBQ;EACE,qBAAA;EACA,8FAAA;EACA,+CAAA;AAvBV;AAyBU;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAvBZ;AA6BQ;EACE,mBAAA;EACA,cAAA;AA3BV;AA8BQ;EACE,oBAAA;EACA,gBAAA;EACA,4BAAA;AA5BV;AA+BQ;EACE,SAAA;EACA,iCAAA;EACA,mBAAA;AA7BV;AAmCE;EACE,eAAA;AAjCJ;AAsCM;EACE,qBAAA;EACA,4BAAA;EACA,gBAAA;AApCR;AAuCM;EACE,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AArCR;AAuCQ;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AArCV;AAwCQ;EACE,iBAAA;EACA,4BAAA;EACA,mBAAA;AAtCV;AAwCU;EACE,4BAAA;EACA,gBAAA;AAtCZ;AA+CM;EACE,oBAAA;EACA,iCAAA;EACA,mBAAA;AA7CR;AAkDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;AAhDJ;AAkDI;EACE,aAAA;EACA,SAAA;AAhDN;AAmDI;EACE,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAjDN;AAoDI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAlDN;AAoDM;EACE,6DAAA;EACA,2BAAA;EACA,6CAAA;AAlDR;AAqDM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAnDR;AAuDI;EACE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AArDN;AAuDM;EACE,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AArDR;AA0DE;EACE,qBAAA;AAxDJ;AA0DI;EACE,gBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;AAxDN;AA0DM;EACE,yBAAA;AAxDR;AA4DI;;EAEE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,4BAAA;AA1DN;AA4DM;;EACE,qBAAA;EACA,8CAAA;EACA,2BAAA;AAzDR;AA4DM;;EACE,qBAAA;AAzDR;AA0DQ;;EACE,qBAAA;EACA,4CAAA;AAvDV;AA2DM;;EACE,cAAA;EACA,kBAAA;AAxDR;AA4DI;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA1DN;AA4DM;EACE,aAAA;EACA,qBAAA;AA1DR;AAgEM;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA9DR;AAgEM;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AA9DR;AAgEM;;EAEE,YAAA;EACA,uBAAA;EACA,UAAA;AA9DR;AAmEE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,6CAAA;AAjEJ;AAmEI;EACE,6DAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AAjEN;AAmEM;EACE,6DAAA;EACA,2BAAA;EACA,+CAAA;AAjER;AAoEM;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAlER;AAsEI;EACE,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;AApEN;AAsEM;EACE,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AApER;AAyEE;EACE,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;AAvEJ;AAyEI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAvEN;AA0EI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAxEN;AA2EI;EACE,6DAAA;EACA,cAAA;EACA,8BAAA;AAzEN;AA6EE;EACE,kBAAA;EACA,kBAAA;AA3EJ;AA6EI;EACE,gBAAA;EACA,cAAA;AA3EN;;AAmFI;EACE,6DAAA;AAhFN;AAoFM;EACE,6DAAA;AAlFR;AAyFU;EACE,2CAAA;AAvFZ;AA6FI;;EAEE,2CAAA;EACA,2CAAA;EACA,4BAAA;AA3FN;AA6FM;;EACE,2CAAA;AA1FR;;AAiGA;EACE;IACE,aAAA;EA9FF;EAgGE;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EA9FJ;EAgGI;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EA9FN;EAkGE;IACE,sBAAA;EAhGJ;EAkGI;;IAEE,WAAA;EAhGN;EAsGM;IACE,oBAAA;IACA,mBAAA;EApGR;AACF;AA0GA;EAGM;IACE,aAAA;EA1GN;EA8GE;IACE,mBAAA;EA5GJ;AACF","sourcesContent":[".order-action-container {\n  padding: 1.5rem;\n  background-color: var(--cui-body-bg);\n  min-height: 100vh;\n\n  .order-action-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid var(--cui-border-color);\n\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n\n      .back-button {\n        border-radius: 0.5rem;\n        padding: 0.5rem 1rem;\n        font-weight: 500;\n        transition: all 0.3s ease;\n\n        &:hover {\n          transform: translateX(-2px);\n          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n        }\n      }\n\n      .header-title {\n        h3 {\n          margin: 0;\n          font-weight: 600;\n          color: var(--cui-body-color);\n          font-size: 1.5rem;\n        }\n\n        .header-subtitle {\n          color: var(--cui-secondary-color);\n          font-size: 0.875rem;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .order-info-card {\n    border: none;\n    border-radius: 0.75rem;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n\n    .card-body {\n      padding: 1.5rem;\n    }\n\n    .info-item {\n      .info-label {\n        font-size: 0.75rem;\n        font-weight: 500;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        opacity: 0.8;\n        margin-bottom: 0.25rem;\n      }\n\n      .info-value {\n        font-size: 1rem;\n        font-weight: 600;\n        margin: 0;\n      }\n    }\n  }\n\n  .action-form-card {\n    border: none;\n    border-radius: 0.75rem;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    overflow: hidden;\n\n    .form-header {\n      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n      border-bottom: 1px solid var(--cui-border-color);\n      padding: 1.25rem 1.5rem;\n\n      h5 {\n        margin: 0;\n        font-weight: 600;\n        color: var(--cui-body-color);\n      }\n    }\n\n    .card-body {\n      padding: 2rem;\n    }\n  }\n\n  .wizard-progress {\n    .progress-bar {\n      height: 8px;\n      border-radius: 4px;\n      background-color: #e9ecef;\n      \n      .progress-bar {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        border-radius: 4px;\n      }\n    }\n    \n    .progress-text {\n      text-align: center;\n      margin-top: 0.5rem;\n      font-weight: 500;\n      color: var(--cui-secondary-color);\n      font-size: 0.875rem;\n    }\n  }\n\n  .action-selection {\n    .selection-grid {\n      display: grid;\n      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n      gap: 1.5rem;\n      margin-top: 1rem;\n\n      .selection-card {\n        background: white;\n        border: 2px solid #e9ecef;\n        border-radius: 0.75rem;\n        padding: 2rem 1.5rem;\n        text-align: center;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        position: relative;\n        overflow: hidden;\n\n        &:hover {\n          transform: translateY(-4px);\n          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n          border-color: #667eea;\n        }\n\n        &.selected {\n          border-color: #667eea;\n          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\n          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);\n\n          &::before {\n            content: '✓';\n            position: absolute;\n            top: 1rem;\n            right: 1rem;\n            width: 24px;\n            height: 24px;\n            background: #667eea;\n            color: white;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-weight: bold;\n            font-size: 0.875rem;\n          }\n        }\n\n\n\n        .card-icon {\n          margin-bottom: 1rem;\n          color: #667eea;\n        }\n\n        h5 {\n          margin: 0 0 0.5rem 0;\n          font-weight: 600;\n          color: var(--cui-body-color);\n        }\n\n        p {\n          margin: 0;\n          color: var(--cui-secondary-color);\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n\n  .form-step {\n    padding: 1rem 0;\n  }\n\n  .review-step {\n    .review-summary {\n      h5 {\n        margin-bottom: 1.5rem;\n        color: var(--cui-body-color);\n        font-weight: 600;\n      }\n\n      .review-item {\n        background: #f8f9fa;\n        border-radius: 0.5rem;\n        padding: 1.5rem;\n        margin-bottom: 1rem;\n        border-left: 4px solid #667eea;\n\n        h6 {\n          margin: 0 0 1rem 0;\n          color: #667eea;\n          font-weight: 600;\n          font-size: 1rem;\n        }\n\n        p {\n          margin: 0.25rem 0;\n          color: var(--cui-body-color);\n          font-size: 0.875rem;\n\n          strong {\n            color: var(--cui-body-color);\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n\n  .wizard-form-card {\n    .form-header {\n      .step-description {\n        margin: 0.5rem 0 0 0;\n        color: var(--cui-secondary-color);\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  .wizard-navigation {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    padding-top: 2rem;\n    border-top: 1px solid var(--cui-border-color);\n\n    .nav-right {\n      display: flex;\n      gap: 1rem;\n    }\n\n    .nav-button {\n      border-radius: 0.5rem;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n    }\n\n    .submit-button {\n      background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n      border: none;\n      border-radius: 0.5rem;\n      padding: 0.75rem 2rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      &:hover {\n        background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);\n      }\n\n      &:disabled {\n        background: #adb5bd;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n\n    .cancel-button {\n      border: 2px solid #6c757d;\n      border-radius: 0.5rem;\n      padding: 0.75rem 2rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      &:hover {\n        background-color: #6c757d;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);\n      }\n    }\n  }\n\n  .form-group {\n    margin-bottom: 1.5rem;\n\n    .form-label {\n      font-weight: 600;\n      color: var(--cui-body-color);\n      margin-bottom: 0.5rem;\n      font-size: 0.875rem;\n\n      .text-danger {\n        color: #dc3545 !important;\n      }\n    }\n\n    .form-control,\n    .form-select {\n      border: 2px solid #e9ecef;\n      border-radius: 0.5rem;\n      padding: 0.75rem 1rem;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      background-color: var(--cui-body-bg);\n      color: var(--cui-body-color);\n\n      &:focus {\n        border-color: #667eea;\n        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n        transform: translateY(-1px);\n      }\n\n      &.is-invalid {\n        border-color: #dc3545;\n        &:focus {\n          border-color: #dc3545;\n          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n        }\n      }\n\n      &::placeholder {\n        color: #adb5bd;\n        font-style: italic;\n      }\n    }\n\n    .invalid-feedback {\n      display: block !important;\n      font-size: 0.75rem;\n      color: #dc3545;\n      margin-top: 0.25rem;\n      font-weight: 500;\n\n      &::before {\n        content: '⚠ ';\n        margin-right: 0.25rem;\n      }\n    }\n    \n    // Ensure currency-like split inputs look correct inside OrderAction\n    .price-input-group {\n      .form-control {\n        border: none;\n        background: transparent;\n        padding: 0;\n        box-shadow: none;\n      }\n      .form-control:focus {\n        border: none;\n        background: transparent;\n        padding: 0;\n        box-shadow: none;\n      }\n      .price-whole,\n      .price-decimal {\n        border: none;\n        background: transparent;\n        padding: 0;\n      }\n    }\n  }\n\n  .form-actions {\n    display: flex;\n    gap: 1rem;\n    justify-content: flex-end;\n    margin-top: 2rem;\n    padding-top: 2rem;\n    border-top: 1px solid var(--cui-border-color);\n\n    .submit-button {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border: none;\n      border-radius: 0.5rem;\n      padding: 0.75rem 2rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      &:hover {\n        background: linear-gradient(135deg, #5a6fd8 0%, #6a42a0 100%);\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);\n      }\n\n      &:disabled {\n        background: #adb5bd;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n\n    .cancel-button {\n      border: 2px solid #6c757d;\n      border-radius: 0.5rem;\n      padding: 0.75rem 2rem;\n      font-weight: 600;\n      font-size: 0.875rem;\n      transition: all 0.3s ease;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n\n      &:hover {\n        background-color: #6c757d;\n        color: white;\n        transform: translateY(-2px);\n        box-shadow: 0 8px 25px rgba(108, 117, 125, 0.2);\n      }\n    }\n  }\n\n  .alert {\n    border-radius: 0.5rem;\n    border: none;\n    padding: 1rem 1.5rem;\n    margin-bottom: 1.5rem;\n\n    &.alert-success {\n      background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);\n      color: #155724;\n      border-left: 4px solid #28a745;\n    }\n\n    &.alert-danger {\n      background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);\n      color: #721c24;\n      border-left: 4px solid #dc3545;\n    }\n\n    &.alert-warning {\n      background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);\n      color: #856404;\n      border-left: 4px solid #ffc107;\n    }\n  }\n\n  .order-action-not-found {\n    text-align: center;\n    padding: 3rem 1rem;\n\n    .warning-alert {\n      max-width: 500px;\n      margin: 0 auto;\n    }\n  }\n}\n\n// Dark theme support\nhtml[data-coreui-theme=\"dark\"] {\n  .order-action-container {\n    .order-info-card {\n      background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n    }\n\n    .action-form-card {\n      .form-header {\n        background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n      }\n    }\n\n    .custom-tabs {\n      .nav-item {\n        .custom-tab-link {\n          &.active {\n            background-color: var(--cui-dark-bg-subtle);\n          }\n        }\n      }\n    }\n\n    .form-control,\n    .form-select {\n      background-color: var(--cui-dark-bg-subtle);\n      border-color: var(--cui-dark-border-subtle);\n      color: var(--cui-body-color);\n\n      &:focus {\n        background-color: var(--cui-dark-bg-subtle);\n      }\n    }\n  }\n}\n\n// Responsive adjustments\n@media (max-width: 768px) {\n  .order-action-container {\n    padding: 1rem;\n\n    .order-action-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 1rem;\n\n      .header-left {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n      }\n    }\n\n    .form-actions {\n      flex-direction: column;\n\n      .submit-button,\n      .cancel-button {\n        width: 100%;\n      }\n    }\n\n    .custom-tabs {\n      .nav-item {\n        .custom-tab-link {\n          padding: 0.5rem 1rem;\n          font-size: 0.875rem;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .order-action-container {\n    .action-form-card {\n      .card-body {\n        padding: 1rem;\n      }\n    }\n\n    .form-group {\n      margin-bottom: 1rem;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
